export const MODAL_EVENTS = {
  open: 'modals-context:open-modal',
  close: 'modals-context:close-modal',
};
